<template>
        <BasePopUpDialog v-model="value" :maxBodyWidth="450" :maxBodyHeight="400" icon="event_note" title="Send Notification">
              <div slot="dialogBody">
                   <v-form ref="form" class="mainForm" no-gutters>
                        <v-label class="mb-1">Current selection: <span style="font-weight:bold">{{commTitle}}</span></v-label>
                         <v-list dense ref="selector" :class="selectorClass">
                            <v-list-item-group
                                    v-model="sendGroup"
                                    multiple
                                    color="indigo"
                            >
                            <v-list-item
                                v-for="(item,i) in userGroups"
                                :key="i"
                                active-class="primary--text text--accent-4"
                            >
                            <template v-slot:default="{ active, toggle }">
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.repGroup"></v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-checkbox
                                    :input-value="active"
                                    :true-value="item"
                                    color="primary accent-4"
                                    @click.stop="toggle"
                                    ></v-checkbox>
                                </v-list-item-action>
                                </template>
                            </v-list-item>
                    
                    </v-list-item-group>
                </v-list>
                 <VMessages class="mt-1" :value="errorMessage" color="error"></VMessages>
                     </v-form>
             </div>
              <div slot="dialogFooter">
                  <v-card-actions>
                      
                        <v-checkbox
                            align-self="center"
                            v-model="selectAll"
                            color="primary accent-4"
                            @change="toggleSelectAll"
                            hide-details
                            dense
                            label="Select All"
                            class="mt-1 mb-3 mr-3"
                        ></v-checkbox>                        
                        <v-tooltip color="#feffcd" content-class="tooltip" top max-width="400"> 
                            <template v-slot:activator="{ on, attrs }">
                                <span class="tooltipElement" v-bind="attrs" v-on="on">
                                    <v-checkbox
                                v-model="isResend"
                                hide-details
                                color="primary accent-4"
                                dense
                                label="Resend To All"
                                class="mt-1 mb-3 ml-3"
                                ></v-checkbox>
                                </span>
                            </template>
                            <div>{{resend_to_all_tooltip}}</div>
                        </v-tooltip>

                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="send">
                            Send
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="onCloseDlg">
                            Cancel
                        </v-btn>
              </v-card-actions>
              </div>
        </BasePopUpDialog>
</template>

<script>
import BasePopUpDialog from "@/dialogs/base-popup-dialog.vue";
import VMessages from 'vuetify/lib/components/VMessages/VMessages.js';
export default {
    name:"sendNotificationDialog",
    props:['value','userGroups','commTitle'],
    components:{VMessages,BasePopUpDialog},
    data(){
        return {
            sendGroup:[],
            selectAll:false,
            hasError:false,
            errorMessage:[],
            isResend: false,
            resend_to_all_tooltip: 'By enabling this, the customers will receive the notification again '+
                                    'even if same notification has been received before by customer.'
        }
    },
    computed:{
        seletedItems(){
            return this.sendGroup.length;
        },
        selectorClass(){
            let clazz = "userGroup";
            if(this.hasError){
                clazz += " errorBorder";
            }
            return clazz;
        }
    },
    watch:{
        seletedItems(val){
            if(val < this.userGroups.length){
                this.selectAll = false;
            }else if(val == this.userGroups.length){
                this.selectAll = true;
            }

            if(val>0){
                this.hasError = false;
                this.errorMessage = [];
            }
        },
        isResend(){
            console.log("resend checkbox:" +this.isResend);
        }
        
    },
    methods:{
        onCloseDlg(){
            this.$refs.selector.$el.scrollTop = 0;
            this.sendGroup = [];
            this.selectAll = false;
            this.hasError = false;
            this.isResend = false;
            this.errorMessage = [];
            this.$emit("input",false);
        },
        toggleSelectAll(){
            if(this.selectAll){
                this.sendGroup = this.userGroups.map((e,index)=>{
                    return index;
                    });
            }else{
                this.sendGroup = [];
            }
        },
        send(){
            if(this.sendGroup.length == 0){
                this.hasError = true;
                this.errorMessage = ["Please select at least one group"];
                return;
            }
            const groups = [];
            this.sendGroup.forEach(element => {
                groups.push(this.userGroups[element].repGroup);
            });
            console.log("Send Notification for groups:",groups.join());
            this.$emit("sendNotification",{userGroups:groups.join(), isResend:this.isResend});
            this.onCloseDlg();
        }
    }
}
</script>
<style lang="scss" scoped>
.mainForm{
    padding-top: 16px;
}
.userGroup{
    border: 2px lightgray solid;
}
.errorBorder{
    border: 2px red solid !important;
}
.checkbox{
    margin-right:4%;
}

</style>
<style lang="scss">
.v-label{
    font-size: 0.875rem !important;
}
</style>